/* eslint-disable import/no-cycle */
import { Module } from 'vuex';

import { RootStateI } from '../state';
import { state, ProjectStateI } from './state';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

const module: Module<ProjectStateI, RootStateI> = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
};

export default module;
